module.exports = __webpack_public_path__ + "img/cover.5168b601.jpg";